import React from 'react';
import { UserData } from '../../UserContext';
import ProviderProfileView from '../../components/ProviderProfileView';
import { ProviderProfile } from '../../apiClient';
import { formatAppointmentDateTime } from '../../lib/dateFormatting';
import Container from '../../components/Container';
import Heading2 from '../../components/Heading2';

interface AppointmentBookedViewModel {
  formattedDateTime: string;
  addressLine1: string;
  addressLine2?: string;
  cityStateZip: string;
  providerProfile?: ProviderProfile;
}

export const appointmentBookedViewModel = (userData: UserData): AppointmentBookedViewModel => {
  const homeAddress = userData.homeAddress;
  const providerProfile = userData.providerProfile;

  return {
    formattedDateTime: userData.timeSlot ? formatAppointmentDateTime(userData.timeSlot) : '',
    addressLine1: homeAddress?.address_1 || 'Address Line 1 Unavailable',
    addressLine2: homeAddress?.address_2,
    cityStateZip: `${homeAddress?.city || 'City Unavailable'}, ${homeAddress?.state || 'State Unavailable'} ${
      homeAddress?.zip_code || 'Zip Code Unavailable'
    }`,
    providerProfile: providerProfile,
  };
};

interface AppointmentBookedProps {
  viewModel: AppointmentBookedViewModel;
}

const AppointmentBooked = ({ viewModel }: AppointmentBookedProps) => {
  return (
    <Container>
      <Heading2>Your Appointment is Confirmed</Heading2>
      <div className="mb-8">
        <h3 className="font-bold text-center text-xl mb-3">Important Next Steps:</h3>
        <p className="mb-4">
          Now that your apointment is booked,{' '}
          <a className="font-bold" href="https://book.skinclique.com/webstoreNew/user/signIn">
            please sign in to your account using the email and password you provided to complete your pre-appointment
            paperwork.
          </a>{' '}
          This should be completed at least 48hr ahead of your appointment to ensure that your provider has all the
          information necessary.
        </p>
        <div className="text-center">
          <a
            href="https://book.skinclique.com/webstoreNew/user/signIn"
            className="button button--black button--centered"
          >
            Sign In
          </a>
        </div>
      </div>

      <h3 className="font-bold text-center text-xl mb-3">Appointment Details:</h3>
      <p className="text-center mb-4">
        <span className="bg-clique-yellow px-2 py-1 text-xl font-semibold">{viewModel.formattedDateTime}</span>
      </p>
      <p className="text-center mb-4">
        <p>
          {viewModel.addressLine1} <br />
          {viewModel.addressLine2 && (
            <>
              {viewModel.addressLine2} <br />
            </>
          )}
          {viewModel.cityStateZip}
        </p>
      </p>

      <div className="flex justify-center mt-8">
        {viewModel.providerProfile && (
          <ProviderProfileView
            name={viewModel.providerProfile.fullName}
            credentials={viewModel.providerProfile.credentials}
            bio={viewModel.providerProfile.bio}
            imageUrl={viewModel.providerProfile.image}
          />
        )}
      </div>
    </Container>
  );
};

export default AppointmentBooked;
